export const NEW_PRESCRIPTION_RECEIVED = "NEW_PRESCRIPTION_RECEIVED";
export const PRESCRIPTION_HISTORY_RECEIVED = "PRESCRIPTION_HISTORY_RECEIVED";
export const REFILL_REQUEST_RECEIVED = "REFILL_REQUEST_RECEIVED";
export const PRACTITIONER_PRESCRIPTION_HISTORY_RECEIVED =
  "PRACTITIONER_PRESCRIPTION_HISTORY_RECEIVED";
export const ORDERED_PRESCRIPTION_RECEIVED = "ORDERED_PRESCRIPTION_RECEIVED";
export const PRACTITIONER_HISTORY_PRESCRIPTION_RECEIVED =
  "PRACTITIONER_HISTORY_PRESCRIPTION_RECEIVED";
export const PRACTITIONER_UNFINALIZED_PRESCRIPTION_RECEIVED =
  "PRACTITIONER_UNFINALIZED_PRESCRIPTION_RECEIVED";
export const UNORDERED_PRESCRIPTION_RECEIVED =
  "UNORDERED_PRESCRIPTION_RECEIVED";
export const UNFINALIZED_PRESCRIPTIONI_ID_RECEIVED =
  "UNFINALIZED_PRESCRIPTIONI_ID_RECEIVED";
export const CLEAR_UNFINALIZED_PRESCRIPTION = "CLEAR_UNFINALIZED_PRESCRIPTION";
export const PRESCRIPTION_PAGE_TAB_SHOW_ITEM_LIST =
  "PRESCRIPTION_PAGE_TAB_SHOW_ITEM_LIST";
export const CLEAR_HISTORY_PRESCRIPTION = "CLEAR_HISTORY_PRESCRIPTION";
